import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-443b9392"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex col grow" }
const _hoisted_2 = { class: "flex align-center col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Module :", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-red"
}
const _hoisted_5 = { class: "flex align-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "to", -1))
const _hoisted_7 = { class: "flex col" }
const _hoisted_8 = {
  style: {"width":"50vw","gap":"24px"},
  class: "flex col align-start"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Vers quelle base de données voulez vous exporter ces tâches : ", -1))
const _hoisted_10 = {
  ref: "container",
  class: "flex col grow",
  style: {"overflow":"scroll"}
}
const _hoisted_11 = {
  ref: "stickContainer",
  class: "flex col header-sticky"
}
const _hoisted_12 = { class: "flex justify-between align-center" }
const _hoisted_13 = { class: "flex align-center" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "flex align-center" }
const _hoisted_16 = {
  ref: "container",
  class: "table-container scrollbars"
}
const _hoisted_17 = { ref: "tbody" }
const _hoisted_18 = { class: "f12" }
const _hoisted_19 = { width: "50" }
const _hoisted_20 = {
  style: {"width":"50px"},
  class: "flex align-center justify-center"
}
const _hoisted_21 = { width: "350" }
const _hoisted_22 = {
  style: {"width":"350px"},
  class: "flex justify-between align-center g6"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Nom", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "flex justify-between align-center g6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Actif", -1))
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "flex justify-between align-center g6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Manager", -1))
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "flex justify-between align-center g6" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Recurrence", -1))
const _hoisted_33 = { key: 3 }
const _hoisted_34 = { class: "flex justify-between align-center g6" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Type", -1))
const _hoisted_36 = { key: 4 }
const _hoisted_37 = { class: "flex justify-between align-center g6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Horaires", -1))
const _hoisted_39 = { key: 5 }
const _hoisted_40 = { class: "flex justify-between align-center g6" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Sous-tâches", -1))
const _hoisted_42 = { key: 6 }
const _hoisted_43 = { class: "flex justify-between align-center g6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Éléments", -1))
const _hoisted_45 = { key: 7 }
const _hoisted_46 = { class: "flex justify-between align-center g6" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Éléments", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Actions", -1))
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "flex col justify-between align-center" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { key: 3 }
const _hoisted_55 = { class: "flex align-center justify-between" }
const _hoisted_56 = {
  key: 0,
  class: "edit-btn"
}
const _hoisted_57 = { class: "bold" }
const _hoisted_58 = { key: 4 }
const _hoisted_59 = { class: "flex grow" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { key: 5 }
const _hoisted_62 = { key: 6 }
const _hoisted_63 = { key: 7 }
const _hoisted_64 = { class: "flex div align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeColorPicker = _resolveComponent("SeColorPicker")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_RRuleInput = _resolveComponent("RRuleInput")!
  const _component_SeCheckBox = _resolveComponent("SeCheckBox")!
  const _component_SeChipList = _resolveComponent("SeChipList")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('add'),
      ref: "taskTypeModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SeInput, {
            ref: "taskTypeName",
            placeholder: _ctx.Lang.getI18N('name')
          }, null, 8, ["placeholder"]),
          _createVNode(_component_SeColorPicker, { ref: "colorPicker" }, null, 512),
          _createVNode(_component_SeButton, {
            onPress: _ctx.modifyOrCreateTaskType,
            class: "modal-valid w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("apply")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      ref: "newTaskModal",
      title: _ctx.Lang.getI18N('new-task')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_SeDropdown, {
            search: true,
            modelValue: _ctx.state.selectedModule,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.selectedModule) = $event)),
            titleFunc: (x) => _ctx.Lang.getI18N(x.toString())
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeDropdownItem, {
                value: _ctx.ModuleEnum.Temperatures
              }, null, 8, ["value"]),
              _createVNode(_component_SeDropdownItem, {
                value: _ctx.ModuleEnum.Action
              }, null, 8, ["value"]),
              _createVNode(_component_SeDropdownItem, {
                value: _ctx.ModuleEnum.Oils
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue", "titleFunc"]),
          _createVNode(_component_SeButton, {
            onPress: _ctx.createNewTask,
            class: "w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      ref: "scheduleModal",
      title: _ctx.Lang.getI18N('schedule')
    }, {
      default: _withCtx(() => [
        (_ctx.scheduleStart > _ctx.scheduleEnd)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.Lang.getI18N("schedule-incoherent")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_VDatePicker, {
            is24hr: "",
            "hide-time-header": "",
            modelValue: _ctx.scheduleStart,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scheduleStart) = $event)),
            mode: "time"
          }, null, 8, ["modelValue"]),
          _hoisted_6,
          _createVNode(_component_VDatePicker, {
            is24hr: "",
            "hide-time-header": "",
            modelValue: _ctx.scheduleEnd,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scheduleEnd) = $event)),
            mode: "time"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_SeButton, {
            class: "modal-valid",
            onPress: _ctx.closeScheduleModal,
            icon: "/ico/edit.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: "Recurrence",
      ref: "rruleModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RRuleInput, {
          style: {"width":"60rem"},
          ref: "rruleInput"
        }, null, 512),
        _createVNode(_component_SeButton, {
          class: "modal-valid w100",
          onPress: _ctx.closeRRuleModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('export'),
      ref: "exportModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_SeDropdown, {
              search: true,
              modelValue: _ctx.state.targetStore,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.targetStore) = $event)),
              titleFunc: (store) => store.name,
              class: "w100"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.stores, (store) => {
                  return (_openBlock(), _createBlock(_component_SeDropdownItem, { value: store }, null, 8, ["value"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue", "titleFunc"]),
            _createVNode(_component_SeCheckBox, { ref: "exportAttachments" }, {
              default: _withCtx(() => [
                _createTextVNode("Exporter les pièces jointes")
              ]),
              _: 1
            }, 512),
            _createVNode(_component_SeButton, {
              onPress: _ctx.exportTasks,
              class: "w100"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("export")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_SeChipList, {
              ref: "chips",
              changed: _ctx.onFilterChange,
              labels: ['General', 'Actions', 'Temperatures', 'Oils']
            }, null, 8, ["changed"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_SeButton, {
              onPress: _ctx.openNewTaskModal,
              icon: "ico/plus.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("new-task")), 1)
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_SeButton, {
              ref: "exportBtn",
              onPress: _ctx.openExportModal,
              icon: "ico/export.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("export")), 1)
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_SeButton, {
              ref: "saveBtn",
              onPress: _ctx.save,
              icon: "ico/save.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("save")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_SearchBar, {
            searchChange: _ctx.onSearchChange,
            calm: true,
            class: "grow",
            placeholderBase: _ctx.Lang.getI18N('search')
          }, null, 8, ["searchChange", "placeholderBase"])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", _hoisted_17, [
            _createElementVNode("tr", _hoisted_18, [
              _createElementVNode("th", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_SeCheckBox, {
                    ref: "globalCheck",
                    onClick: _ctx.applyGlobalCheck
                  }, null, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("th", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("img", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.revertName && _ctx.revertName(...args))),
                    class: "revert-btn",
                    src: "ico/refresh.svg"
                  })
                ])
              ]),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("th", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("img", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.revertActive && _ctx.revertActive(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("img", {
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.revertManager && _ctx.revertManager(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("th", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("img", {
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.revertRecurrence && _ctx.revertRecurrence(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("th", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("img", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.revertType && _ctx.revertType(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("th", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("img", {
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.revertSchedule && _ctx.revertSchedule(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isActions)
                ? (_openBlock(), _createElementBlock("th", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("img", {
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.revertConfigurations && _ctx.revertConfigurations(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isTemperatures)
                ? (_openBlock(), _createElementBlock("th", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("img", {
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.revertConfigurations && _ctx.revertConfigurations(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isOils)
                ? (_openBlock(), _createElementBlock("th", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("img", {
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.revertConfigurations && _ctx.revertConfigurations(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_48
            ])
          ], 512),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.displayTasks, (task) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", {
                class: "cell-hover",
                onClick: ($event: any) => (_ctx.onRowClick(task))
              }, [
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_SeCheckBox, {
                    readonly: true,
                    checked: _ctx.checkedTasks.includes(task)
                  }, null, 8, ["checked"])
                ])
              ], 8, _hoisted_49),
              _createElementVNode("td", null, [
                _createVNode(_component_ReadonlyField, {
                  locked: task.originValue?.name_lock,
                  class: "flex justify-between align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeInput, {
                      inputChange: _ctx.onNameChange,
                      modelValue: task.name,
                      "onUpdate:modelValue": ($event: any) => ((task.name) = $event),
                      value: task.getName()
                    }, null, 8, ["inputChange", "modelValue", "onUpdate:modelValue", "value"])
                  ]),
                  _: 2
                }, 1032, ["locked"])
              ]),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                    _createVNode(_component_ReadonlyField, {
                      locked: task.originValue?.active_lock,
                      class: "flex justify-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ToggleSwitch, {
                          defaultValue: task.getActive(),
                          click: _ctx.onActiveChange,
                          modelValue: task.active,
                          "onUpdate:modelValue": ($event: any) => ((task.active) = $event)
                        }, null, 8, ["defaultValue", "click", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["locked"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("td", _hoisted_52, [
                    _createVNode(_component_ReadonlyField, {
                      locked: task.originValue?.requires_manager_lock,
                      class: "flex justify-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ToggleSwitch, {
                          click: _ctx.onManagerChange,
                          modelValue: task.requires_manager,
                          "onUpdate:modelValue": ($event: any) => ((task.requires_manager) = $event)
                        }, null, 8, ["click", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["locked"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("td", _hoisted_53, [
                    _createVNode(_component_ReadonlyField, {
                      locked: task.originValue?.recurrence_lock,
                      class: "flex justify-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SeButton, {
                          icon: "/ico/edit.svg",
                          onPress: () => _ctx.openRRuleModal(task)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.recurrenceTitle(task)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onPress"])
                      ]),
                      _: 2
                    }, 1032, ["locked"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                    _createVNode(_component_ReadonlyField, {
                      locked: task.originValue?.type_lock,
                      onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                      class: "flex justify-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SeDropdown, {
                          onSelectionChanged: _ctx.onTypeChange,
                          nullable: true,
                          modelValue: task.type,
                          "onUpdate:modelValue": ($event: any) => ((task.type) = $event),
                          titleFunc: (type) => _ctx.state.getTypeName(type)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.taskTypes.map((x) => x.ref), (taskType) => {
                              return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                                displayTitle: false,
                                value: taskType
                              }, {
                                heading: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("div", {
                                      class: "color-chip",
                                      style: _normalizeStyle('background-color:' + _ctx.state.getTypeColor(taskType)
                        )
                                    }, null, 4),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.state.getTypeName(taskType)), 1)
                                  ])
                                ]),
                                tailing: _withCtx(() => [
                                  (_ctx.state.getTaskType(taskType)?.storeSide)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                        _createVNode(_component_SeImage, {
                                          onClick: () => _ctx.openEditTaskTypeModal(taskType),
                                          maxWidth: 18,
                                          maxHeight: 18,
                                          src: "/ico/edit-blue.svg"
                                        }, null, 8, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 256)),
                            _createVNode(_component_SeDropdownItem, {
                              displayTitle: false,
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openTaskTypeModal())),
                              class: "noselect"
                            }, {
                              heading: _withCtx(() => [
                                _createElementVNode("span", _hoisted_57, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onSelectionChanged", "modelValue", "onUpdate:modelValue", "titleFunc"])
                      ]),
                      _: 2
                    }, 1032, ["locked"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isGeneral)
                ? (_openBlock(), _createElementBlock("td", _hoisted_58, [
                    _createVNode(_component_ReadonlyField, {
                      onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                      locked: task.originValue?.schedule_lock,
                      class: "flex justify-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.getStarts(), (start, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "time-chip",
                              onClick: ($event: any) => (_ctx.openScheduleModal(task, index))
                            }, _toDisplayString(_ctx.formatDate(start, start + task.getDurations()[index])), 9, _hoisted_60))
                          }), 256))
                        ]),
                        _createVNode(_component_SeFadeButton, {
                          onClick: ($event: any) => (_ctx.openScheduleModal(task, null)),
                          icon: "/ico/plus-blue.svg"
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["locked"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isActions)
                ? (_openBlock(), _createElementBlock("td", _hoisted_61, [
                    _createVNode(_component_ReadonlyField, {
                      locked: task.originValue?.configuration_lock,
                      class: "flex justify-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SeButton, { icon: "/ico/edit.svg" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.configurationTitle(task)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["locked"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isTemperatures)
                ? (_openBlock(), _createElementBlock("td", _hoisted_62, [
                    _createVNode(_component_ReadonlyField, {
                      locked: task.originValue?.configuration_lock,
                      class: "flex justify-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SeButton, { icon: "/ico/edit.svg" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.configurationTitle(task)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["locked"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.isOils)
                ? (_openBlock(), _createElementBlock("td", _hoisted_63, [
                    _createElementVNode("div", {
                      onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                      class: "flex justify-between align-center"
                    }, [
                      _createVNode(_component_SeButton, { icon: "/ico/edit.svg" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.configurationTitle(task)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_SeFadeButton, {
                    onClick: () => _ctx.openTask(task)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("open")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_SeFadeButton, {
                    onClick: () => _ctx.duplicate(task)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("duplicate")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ])
            ]))
          }), 256))
        ])
      ], 512)
    ], 512)
  ], 64))
}